import { useState, useEffect } from 'react';
import styled from '@emotion/styled'

import { Grid, Card, Button, TextField } from '@mui/material'

import { Panel, SwitchSection, Section, HebrewSpan, TagField, TagRuleDescription, ErrorList, TagRules, validateTemplate } from '../../Common'

import { usePageData } from '../../../../contexts/PageData';
import RadioCards from '../../Components/RadioCards';

import { BasicFlex } from '../../../../utils/Common';

import AttachMoneyRoundedIcon from '@mui/icons-material/AttachMoneyRounded';
import PercentRoundedIcon from '@mui/icons-material/PercentRounded';


const GeneralTab = () => {

  const [amountOver, setAmountOver] = useState(0);

  const [defaultCCRate, setDefaultCCRate] = useState(0);

  const { data, modifySetting, isPending } = usePageData() || {};

  console.log(data?.data, "data");

  let setting = data?.data || {};

  const handleChange = (e, setFunc) => {
    let val = e.target.value;
    setFunc(val);
  }

  const updateSetting = (val, field) => {
    modifySetting(val, field, data?.setting_id);
  }

  useEffect(() => {
    if (setting?.amount_over || setting?.amount_over === 0) {
      setAmountOver(setting?.amount_over || 0);
    }
    
    if (setting?.default_cc_rate || setting?.default_cc_rate === 0) {
      setDefaultCCRate(setting?.default_cc_rate || 0);
    }
  }, [setting?.amount_over, setting?.default_cc_rate]);

  return (
    <Panel>

      <SwitchSection title="Apply CC Fee by Default" description="Apply credit card fee to all credit card payments by default" switchName="use_cc_fee" />

      <Section title="Add Fee for amounts over" description="Only apply credit card fee to amounts over" mainAction={<BasicFlex justify="flex-end" gap="1rem">
          <TextField
            type="number"
            value={amountOver}
            onChange={(e) => handleChange(e, setAmountOver)}
            variant="outlined"
            size='small'
            sx={{width: "10rem", bgcolor: "#fff"}}
            InputProps={{startAdornment: <AttachMoneyRoundedIcon color="basic" fontSize="small" sx={{marginRight: ".5rem"}} />}}
          />
          <Button variant="text" onClick={() => updateSetting(amountOver, "amount_over")} loading={isPending}>Update</Button>
        </BasicFlex>}>
        
      </Section>

      <Section title="Credit Card Fee" description="Fee to apply to credit card payments" mainAction={<BasicFlex justify="flex-end" gap="1rem">
          <TextField
            type="number"
            value={defaultCCRate}
            onChange={(e) => handleChange(e, setDefaultCCRate)}
            variant="outlined"
            size='small'
            sx={{width: "10rem", bgcolor: "#fff"}}
            InputProps={{startAdornment: <PercentRoundedIcon color="basic" fontSize="small" sx={{marginRight: ".5rem"}} />}}
          />
          <Button variant="text" onClick={() => updateSetting(defaultCCRate, "default_cc_rate")} loading={isPending}>Update</Button>
        </BasicFlex>}>
        
      </Section>
    </Panel>
  )
};

export default GeneralTab;